import { render } from "./CustomersDashboard.vue?vue&type=template&id=9baad146&scoped=true&lang=pug"
import script from "./CustomersDashboard.vue?vue&type=script&lang=js"
export * from "./CustomersDashboard.vue?vue&type=script&lang=js"

import "./CustomersDashboard.vue?vue&type=style&index=0&id=9baad146&lang=scss&scoped=true"
import "./CustomersDashboard.vue?vue&type=style&index=1&id=9baad146&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9baad146"]])

export default __exports__